import HttpBackend from 'i18next-http-backend';
import { path, mergeDeepRight } from 'ramda';
import fallback from './translations/fallback.js';

export default class I18nOCCOBackend {
  static type = 'backend';

  init(services, backendOptions = {}, i18nextOptions = {}) {
    this.services = services;
    this.options = backendOptions;
    this.i18nextOptions = i18nextOptions;
    this.missingContextWarningShown = false;

    this.orgBackend = new HttpBackend();

    // All translations are now stored at org level only
    this.orgBackend.init(
      services,
      {
        loadPath: `${backendOptions.cdn}/${backendOptions.orgId}/${backendOptions.projectName}/{{lng}}/{{ns}}.json`,
      },
      i18nextOptions
    );
  }

  read(language, namespace, callback) {
    const { eventCode, orgId, projectName } = this.options;
    const fallbackData = path([projectName, language, namespace], fallback) || {};

    if (!orgId || !eventCode) {
      if (!this.missingContextWarningShown) {
        console.warn(
          '[I18nOCCOBackend] Organisation ID or Event Code is missing. ' +
            'Using bundled translations; remote localization files will not be requested.'
        );
        this.missingContextWarningShown = true;
      }
      callback(null, fallbackData);
      return;
    }

    this.orgBackend.read(language, namespace, (err, data) => {
      let orgData = data;
      if (err) {
        console.warn('[I18nOCCOBackend] Failed to read from org source:', err);
        orgData = {};
      }

      // Transform nested structure to flat key-value pairs
      // Structure: { "key": { "value": "org-level", "eventCode1": "event-specific" } }
      const transformedOrgData = Object.entries(orgData || {}).reduce((acc, [key, val]) => {
        const resolvedValue = eventCode && val[eventCode] !== undefined ? val[eventCode] : val.value;

        if (resolvedValue === undefined) {
          return acc;
        }

        // Use event-specific value if exists, otherwise use org-level value
        acc[key] = resolvedValue;
        return acc;
      }, {});

      const merged = mergeDeepRight(fallbackData, transformedOrgData);

      callback(null, merged);
    });
  }
}
